
export default { 
  //分享至微信好友
  shareWeChatFriend : function(title, desc, imgUrl, linkUrl){    
    var appClient = window.localStorage.appClient
    if(appClient == 'android'){
      ajax.session('{' + String.fromCharCode(34) 
      + 'Ftitle' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + title + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'Fdescribe' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + desc + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'Fimage' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + imgUrl + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'FjumpUrl' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + linkUrl + String.fromCharCode(34) 
      + '}')  
    }else{
      window.webkit.messageHandlers.ajax.postMessage({fun:'session',Ftitle:title,Fdescribe:desc,Fimage:imgUrl,FjumpUrl: linkUrl})
    }
    
  },
  //分享至微信朋友圈
  shareWeChatFriendQuan : function(title, desc, imgUrl, linkUrl){
    var appClient = window.localStorage.appClient
    if(appClient == 'android'){
      ajax.timeLine('{' + String.fromCharCode(34) + 'Ftitle' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + title + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'Fdescribe' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + desc + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'Fimage' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + imgUrl + String.fromCharCode(34)
      + ',' + String.fromCharCode(34) + 'FjumpUrl' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + linkUrl + String.fromCharCode(34)
      + '}')
    }else{
      window.webkit.messageHandlers.ajax.postMessage({fun:'timeLine',Ftitle: title ,Fdescribe: desc,Fimage: imgUrl ,FjumpUrl: linkUrl})
    }
  },
  //分享至微信好友(支持回调)
  shareWeChatFriendCallback : function(title, desc, imgUrl, linkUrl, javascript){    
    var appClient = window.localStorage.appClient
    if(appClient == 'android'){
      ajax.sessionCallback('{' + String.fromCharCode(34) 
      + 'Ftitle' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + title + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'Fdescribe' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + desc + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'Fimage' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + imgUrl + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'FjumpUrl' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + linkUrl + String.fromCharCode(34)
	  + ',' + String.fromCharCode(34) + 'Fjavascript' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + javascript + String.fromCharCode(34)
      + '}')  
    }else{
      window.webkit.messageHandlers.ajax.postMessage({fun:'sessionCallback',Ftitle:title,Fdescribe:desc,Fimage:imgUrl,FjumpUrl: linkUrl,Fjavascript: javascript})
    }
    
  },
  //分享至微信朋友圈
  shareWeChatFriendQuanCallback : function(title, desc, imgUrl, linkUrl, javascript){
    var appClient = window.localStorage.appClient
    if(appClient == 'android'){
      ajax.timeLineCallback('{' + String.fromCharCode(34) + 'Ftitle' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + title + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'Fdescribe' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + desc + String.fromCharCode(34) 
      + ',' + String.fromCharCode(34) + 'Fimage' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + imgUrl + String.fromCharCode(34)
      + ',' + String.fromCharCode(34) + 'FjumpUrl' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + linkUrl + String.fromCharCode(34)
	  + ',' + String.fromCharCode(34) + 'Fjavascript' + String.fromCharCode(34) + ':' + String.fromCharCode(34) + javascript + String.fromCharCode(34)
      + '}')
    }else{
      window.webkit.messageHandlers.ajax.postMessage({fun:'timeLineCallback',Ftitle: title ,Fdescribe: desc,Fimage: imgUrl ,FjumpUrl: linkUrl,Fjavascript: javascript})
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/appShare.js